import  "./lib/php_functions.js";
import  "./external/jquery.browser.min.js";
import  "./external/destroyed.event.jquery.js";
import  "./external/jquery.bind-first.js";
import  "./external/shortcut.js";
import  "./positioning.js";
import  "./external/checkinview.js";
import  "./external/date.js";
import  "./checkcompability.js";
import  "./external/bootstrap-datepicker2.js";
import  "./external/bootstrap-datepicker.ru.js";
import  "./external/jquery.form.js";
import  "./external/jquery.cookie.js";

import  'datatables.net';
import  'datatables.net-bs4';
import  ColVis from 'datatables.net-buttons/js/buttons.colVis.js';
import  'datatables.net-buttons-bs4';
window.ColVis = ColVis;

import  "datatables.net-fixedheader";
import  "datatables.net-fixedheader-bs4";

import  "datatables.net-responsive";
import  "datatables.net-responsive-bs4";

import "datatables.net-colresizewithreorder/ColReorderWithResize.js";

// import  "./external/jquery.dataTables.js";
// import  "./external/jquery.dataTables.extras/ColVis.js";
// import  "./external/jquery.dataTables.extras/FixedHeader.js";

// import  "./fixes.dataTables.js";

import  "./external/wheel.listener.js";
import  "./external/jquery.mousewheel.js";
import  "./external/jquery.tinyscrollbar.js";
import  "./external/jquery.treeview.js";
import  "./external/jquery.treeview.edit.js";
import  "./external/jquery.treeview.async.js";
import  "./external/bootstrap-slider.min.js";
import  "./lib/jquery.powerform.js";

// import  "./qmap/leaflet.js";
// import  "./qmap/leaflet.markercluster.js";
// import  "./qmap/qmap.js";

// import  "./qkb.jquery.js";

import  "./external/jquery.serializejson.my.js";

import  "./lib/common.js";
import  "./lib/jquery.odeann.js";
import  "./lib/bootstrap.button.loading.js";

import  "./qui.jquery.js";
import  "./q.js";
import  "./qform.js";

// import  "./InfoSystem.js";
// import  "./qknowledgebase.js";
// import  "./qhelp.js";
// import  "./qman.js";

import  "./qlist.js";
import  "./external/jquery.maskedinput.js";
import  "./external/placeholder.js";
import  "./redactor/redactor.js";
import  "./redactor/plugins/fullscreen/fullscreen.js";
import  "./redactor/plugins/clips/clips.js";
import  "./redactor/lang/ru.js";
import  "./lib/jquery.powertext.js";
import  "./system.js";
import  "./external/jquery.autocomplete.js";
import  "./external/jquery.numeric.js";
import  "./external/jquery.jstepper.js";
import  "./external/jquery.dragndrop.js";
import  "./external/jquery.dropdown.js";
// import  "./external/video.js";
import  "./sysupdate/sysupdate.base.js";
import  "./sysupdate/sysupdate.server.js";
import  "./sysupdate/sysupdate.client.js";
import  "./sysupdate/sysupdate.js";

// import  "./gis/leaflet1.0.1.min.js";
// import  "./gis/leaflet.draw.js";
// import  "./gis/localization.js";
// import  "./gis/qgis.js";

import  "./fixes.bootstrap.js";
import  "./external/bootstrap-maxlength.js";
import  "./external/highlight.js";

// import  "./qlist2.js";

import  "./external/jquery.quick-outerwidth.js";

// import  "./qgrid.js";

// import  "./testing.js";
import  "./qcalendar.js";

// import  "./qcontrol4persons.js";

import  "./import.js";
import  "./jquery-ui.js";
import  "./qlib.js";
